import { useL10n } from "@ews/react-localization-context";
import { IonSelectOption } from "@ionic/react";
import { SettingsSelectOptionProps } from "./types";

const SettingsSelectOption: React.FC<SettingsSelectOptionProps> = ({
    className,
    value,
    text,
    children,
    disabled
}) =>
{
    const { translate: t } = useL10n();
    return <IonSelectOption disabled={disabled} className={className} value={value}>{t(text)} {children}</IonSelectOption>;
};

export default SettingsSelectOption;